import { render, staticRenderFns } from "./editFood.vue?vue&type=template&id=16cfe26c&scoped=true&"
import script from "./editFood.vue?vue&type=script&lang=js&"
export * from "./editFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cfe26c",
  null
  
)

export default component.exports